import styled from "styled-components";
import useIsResMobile from "lib/hooks/useIsResMobile";

interface ContentAreaProps {
  className?: string;
}

const Wrapper = styled.div`
  margin: 0 auto;
  padding: 0 50px;
  max-width: 960px;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;
`;

const ContentArea: React.FC<ContentAreaProps> = ({ className, children }) => {
  const isResMobile = useIsResMobile();
  return (
    <Wrapper
      className={className}
      css={`
        padding: ${isResMobile ? `0 30px` : `0 50px`};
      `}
    >
      {children}
    </Wrapper>
  );
};

export default ContentArea;
